import { useState } from 'react';
import { toast } from 'sonner';
import { useBargain } from 'app/BargainWidget/context/BargainContext';
import axios from 'axios';

export const useBargainHistory = (initialPage = 0, pageSize = 3) => {
  const { customer, bargainData, currentVariant } = useBargain();

  const customerId = customer?.id;
  const bargainRuleId = bargainData?.id;
  const productId = currentVariant?.productId;
  const variantId = currentVariant?.variantId;

  const [bargainHistory, setBargainHistory] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [loading, setLoading] = useState(false);

  const fetchBargainHistory = async () => {
    if (customerId && bargainRuleId) {
      setLoading(true);
      try {
        const url = `/api/customer-offers/${customerId}/${bargainRuleId}/${productId}/${variantId}`;
        const params = { page: currentPage, size: pageSize, sort: 'offerPrice,desc'};

        const response = await axios.get(url, { params });
        setBargainHistory(response?.data || []);
        const totalCount = response?.headers['x-total-count'];
        setTotalPages(Math.max(1, Math.ceil((Number(totalCount) || 0) / pageSize)));
      } catch (err) {
        toast.error(err?.response?.data?.message || err?.message || 'Failed to fetch bargain history');
      } finally {
        setLoading(false);
      }
    }
  };

  return { bargainHistory, totalPages, currentPage, setCurrentPage, loading, fetchBargainHistory };
};
